module.exports = __webpack_public_path__ + "static/media/batchImportDPState.5f8a5835.xlsx";